import styled from '@emotion/styled'

export const STitleRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  align-items: center;
  text-transform: uppercase;
`
